import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const initialState: any = {
  favVideos: []
};

export const favVideosSlice = createSlice({
  name: 'favVideos',
  initialState,
  reducers: {
    setFavVideos: (state, action: PayloadAction<any[]>) => {
      state.favVideos = action.payload;
    }
  }
});

export const { setFavVideos } = favVideosSlice.actions;

export default favVideosSlice.reducer;
